import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import Footer from "@/components/Footer";
import { RegisterForm } from "@/components/AuthForms";
import { useBranding } from "@/hooks/useBranding";

export default function Register() {
  const branding = useBranding();
  const nav = useNavigate();
  const goBack = () => {
    if (window.history.length > 1) {
      nav(-1);
    } else {
      nav("/");
    }
  };

  return (
    <div className="bg-background">
      <div className="min-h-screen grid lg:grid-cols-2">
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={goBack}
          aria-label="Go back"
          title="Go back"
          className="fixed left-4 top-4 z-50 rounded-full bg-background/80 backdrop-blur"
          data-testid="auth-back-btn"
        >
          <ArrowLeft size={18} weight="bold" />
        </Button>
        <div className="flex items-center justify-center p-6 sm:p-8 lg:p-12 order-2 lg:order-1">
          <div className="w-full max-w-xl">
            <RegisterForm />
          </div>
        </div>

        <div className="hidden lg:flex items-end p-12 bg-primary text-primary-foreground relative overflow-hidden order-1 lg:order-2">
          <div className="absolute inset-0 grain-overlay opacity-40" />
          <div className="relative z-10">
            <Link to="/" className="inline-flex items-center gap-2.5 mb-12">
              <span className="font-display font-bold text-lg">{branding.product_name}</span>
            </Link>
            <h2 className="font-display font-extrabold text-5xl tracking-tight leading-[1.05] max-w-md">
              Your token. Your time. Your visit.
            </h2>
            <p className="mt-5 max-w-md text-primary-foreground/80 leading-relaxed">
              One quick account and you can reserve same-day tokens whenever you need them.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
